import { BaseBloc } from '@core/utils/bloc';
import { EstimatorTemplateListResponse, OrderUpdateItem } from '@business/entities/tm/EstimatorTemplateListResponse';
import { EstimateTemplateListAPI } from '@business/api/estimator_template_list';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { TemplateListFormData } from '@modules/settings/SettingsPage/Components/EstimateTab/Tabs/TmEstimatorTempates/AddEditEstimatorTemplateListModal/EstimatorTemplateListForm';
import { map } from 'rxjs/operators';
import { R } from '@core/utils/r';

export class EstimatorTemplateListBloc extends BaseBloc {
  private readonly listRepo = new Repository<EstimatorTemplateListResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.listRepo.items$.pipe(map(items => R.sortBy(items, 'menuOrder')));

  readonly selectItem = this.listRepo.selectItem;

  onReset() {
    this.listRepo.reset();
  }

  fetchEstimatorTemplateLists = () => {
    return EstimateTemplateListAPI.fetchEstimatorTemplateLists().pipe(
      this.listRepo.ops.addMany(items => items),
      handleMessage({ error: requestMessage('fetch_estimate_template_list_error') }),
    );
  };

  createListItem = (data: TemplateListFormData) => {
    return EstimateTemplateListAPI.createListItem(data).pipe(
      this.listRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_list_item'),
      }),
    );
  };

  updateListItem = (id: string, data: TemplateListFormData) => {
    return EstimateTemplateListAPI.updateListItem(id, data).pipe(
      this.listRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_list_item'),
      }),
    );
  };

  deleteListItem = (id: string) => {
    return EstimateTemplateListAPI.deleteListItem(id).pipe(
      this.listRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_list_item'),
      }),
    );
  };

  updateListOrder = (items: OrderUpdateItem[]) => {
    return EstimateTemplateListAPI.updateListOrder(items);
  };
}
